import logo from 'toscolanomaderno-theme/components/Logo/logo.webp';
import logo2x from 'toscolanomaderno-theme/components/Logo/logo2x.webp';
import logoPng from 'toscolanomaderno-theme/components/Logo/logo.png';
import logo2xPng from 'toscolanomaderno-theme/components/Logo/logo2x.png';

export default function Logo() {
  return (
    <picture className="me-3">
      <source srcSet={`${logo} 1x,${logo2x} 2x`} type="image/webp" />
      <source srcSet={`${logoPng} 1x,${logo2xPng} 2x`} type="image/png" />
      <img alt="" src={logo} width="76" height="100" />
    </picture>
  );
}
